// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'

/**
 * @apiName 获取车辆列表
 * @apiUrl
 */
export function getCarList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 各类型的车总数
 * @apiUrl
 */
export function getCarSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/summary/getCarState',
    method: 'POST',
    data,
  })
}
// 车务状态的列表统计
export function getCarOperationState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/summary/getCarOperationState',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取车源方(服务商列表查询接口)
 * @apiUrl
 */
export function getCarProvider(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 所属车管(新组织结构下获取车管账号)
 * @apiUrl
 */
export function getAllEmployeeList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/getAllEmployeeList',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取车型
 * @apiUrl
 */
export function getCarModelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/modelIdAndName',
    method: 'POST',
    data,
  })
}
// 车辆标签查询
export function getCarLabelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenantCustomTag/list',
    method: 'POST',
    data,
  })
}


/**
 * @apiName orc 获取驾驶证信息
 * @apiUrl
 */
export function getDrivingInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/vehicleLicense',
    method: 'POST',
    data,
  })
}

/**
 * @apiName orc 网约车证
 * @apiUrl
 */
export function getRideHailing(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/rideHailingTransportLicense',
    method: 'POST',
    data,
  })
}

/**
 * @apiName orc 网约车证
 * @apiUrl
 */
export function getNewwork(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/driverHailingLicense',
    method: 'POST',
    data,
  })
}

/**
 * @apiName orc 获取登记证信息
 * @apiUrl
 */
export function getRegistration(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/vehicleRegCert',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 新增车辆
 * @apiUrl
 */
export function addCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/add',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 修改车辆
 * @apiUrl
 */
export function editCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/update',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 车辆详情
 * @apiUrl
 */
export function getCarDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/detail',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 退出运营/恢复运营状态
 * @apiUrl
 */
export function updateOperateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/updateState',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取出入库列表
 * @apiUrl
 */
export function getOutInList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 脱敏出入库列表
 */
export function getOutInListSensitive(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/list/sensitive',
    method: 'POST',
    data,
  })
}

// 出入库详情
export function getOutInDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/details',
    method: 'POST',
    data,
  })
}

// 获取出入库详情提交确认未捕获到的部分信息
export function getTempOutInDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/getStockInfo',
    method: 'POST',
    data,
  })
}


// 添加出入库记录
export function addOutIn(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/add',
    method: 'POST',
    data,
  })
}

// 新增出入库记录查询车辆 合同接口
export function getCarAndContractData(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/addCarAndContractData',
    method: 'POST',
    data,
  })
}

// 编辑出入库记录
export function editOutIn(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/update',
    method: 'POST',
    data,
  })
}

// 获取合同列表
export function getContractList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/list',
    method: 'POST',
    data,
  })
}

// 获取日志列表
export function getLogList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/system/operationLog/list',
    method: 'POST',
    data,
  })
}

// 采购订单列表
export function getPurchaseOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/purchase/order/list',
    method: 'POST',
    data,
  })
}

// 企业租赁订单列表
export function getLeaseOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/lease/order/list',
    method: 'POST',
    data,
  })
}

// 车辆采购信息列表
export function getCarPurchaseOrderInfoList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/purchase/order/info/list',
    method: 'POST',
    data,
  })
}

// 驾驶证OCR识别
export function ocrDriverLicense(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/driverLicense',
    method: 'POST',
    data,
  })
}

// 设为备车-取消备车
export function readyLease(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/readyLease',
    method: 'POST',
    data,
  })
}

// 查询待租标准
export function getCarRentStandardList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carRentStandard/list',
    method: 'POST',
    data,
  })
}

// 编辑待租标准
export function setCarRentStandardEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carRentStandard/edit',
    method: 'POST',
    data,
  })
}

// 提交待审核
export function getcarAuditRecord(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRecord/submit',
    method: 'POST',
    data,
  })
}
// 提交审核结果
export function getcarResult(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carAuditRecord/update',
    method: 'POST',
    data,
  })
}


// tab页数量统计
export function getStockLogSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/summary',
    method: 'POST',
    data,
  })
}

// 获取最新的出入库信息
export function stockLogFindLastOne(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/findLastOne',
    method: 'POST',
    data,
  })
}
// 获取产权方列表
export function propertyOwnerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}

// 查询车辆状态接口
export function getVehicleState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/state/getVehicleState',
    method: 'POST',
    data,
  })
}

// 根据车牌号查询车辆id
export function getCarInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/getCarInfo',
    method: 'POST',
    data,
  })
}

//  新增企业租赁订单
export function AddleaseOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/add',
    method: 'POST',
    data,
  })
}

// 企业订单新增租赁车辆
export function addleaseOrderCarSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/add/v2/car',
    method: 'POST',
    data,
    signParams: [
      'orderId',
      'orderAccruedPlans[0].totalAmount',
      'orderAccruedPlans[0].receivableTotalAmount',
      'orderAccruedPlans[0].planAmount',
    ],
  })
}

// 个人租赁订单详情 + 相关事故、维保状态、违章状态 数量
export function orderDetailAndMore(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/modeConversion/detail',
    method: 'POST',
    data,
  })
}

// 审批任务详情
export function getApprovalTaskDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/getApprovalTaskDetail',
    method: 'POST',
    data,
  })
}


// 切换为动态租金校验接口
export function checkDynamicRent(data = {}) {
  return request({
    url: '/admin/v1/vehicle/dynamic/check',
    method: 'POST',
    data,
    bizCode: [29028],
  })
}

// 动态租金网约平台列表
export function dynamicRentSpList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/dynamic/sp/list',
    method: 'POST',
    data,
    bizCode: [29028],
  })
}

// 动态租金网约平台校验接口
export function dynamicRentSpCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/dynamic/sp/check',
    method: 'POST',
    data,
    bizCode: [29029],
  })
}

/**
 * 查询销售经理列表
 * @param {Object} data 参数
 * @param {string} data.bizType 订单类型（10-个人订单 20-企业订单）
 * @returns {APIResponse<Array>} data为销售经理列表，列表项包含 { salesManagerId-销售经理ID, salesManagerName-销售经理姓名 }
 */
export function querySalesManager(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/querySalesManager',
    method: 'POST',
    data,
  })
}

// 根据订单获取代扣网约平台列表接口
export function rentOrderSpList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/sp/list',
    method: 'POST',
    data,
  })
}

// 换车详情列表
export function changeCarDetailList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/changeCarList',
    method: 'POST',
    data,
  })
}
/**
 * 通过车牌号获取车辆列表
 * @param {string} data.plateNo 车牌号
 * @param {string} data.state 状态 1-全部车辆 2-运营中车辆 3-待租车辆 4-待采购车辆 5-运营中不包含已租
 * @returns data为对象数组 id-车辆ID plateNo-车牌号
 */

export function getSimpleCarList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/simpleDataList',
    method: 'POST',
    data,
  })
}

/**
 * 通过车辆id获取车辆详情
 * @param {number} data.carId 车辆id
 * @returns {number} unavailableType 车辆不可用类型
    50001 命中待租条件-证照状态不可发
    50002 命中待租条件-不可租标签
    50003 命中待租条件-车务状态监控的开启检查项
    50004 已绑定订单-订单已锁定
    50005 已绑定订单-订单换车锁定
 * @returns {number} lockedOrderId 锁定车辆订单id
 * @returns {number} lockedOrderBizType 10-个人订单 20-企业子订单
 */
export function getCarDetailById(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/DataDetail',
    method: 'POST',
    data,
  })
}
